import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone } from 'lucide-react';
import { Button } from './ui/button';

export const CTASection = () => {
  return (
    <section className="py-24 px-6 md:px-12 lg:px-24 relative overflow-hidden" data-testid="cta-section">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#00F0FF]/5 to-transparent" />
      <div className="orb orb-cyan w-[500px] h-[500px] -bottom-40 -right-40 opacity-20" />
      <div className="orb orb-teal w-[300px] h-[300px] -top-20 -left-20 opacity-30" />

      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="trace-border p-8 md:p-16 text-center"
        >
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Ready to <span className="gradient-text">Get Started</span>?
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg mb-10">
            Whether you need welding, repairs, cleaning, or handyman services — 
            we're ready to tackle any challenge. Get your free quote today.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              data-testid="cta-book-button"
              className="btn-primary rounded-none px-10 py-6 text-lg font-heading tracking-wide group"
              asChild
            >
              <Link to="/booking">
                BOOK NOW
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>
            </Button>
            <Button
              data-testid="cta-contact-button"
              variant="outline"
              className="btn-outline rounded-none px-10 py-6 text-lg font-heading tracking-wide"
              asChild
            >
              <Link to="/contact">
                <Phone className="mr-2 w-5 h-5" />
                CONTACT US
              </Link>
            </Button>
          </div>

          {/* Trust Badges */}
          <div className="mt-12 flex flex-wrap justify-center gap-8 text-gray-500">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-[#00F0FF]" />
              <span className="text-sm">Licensed & Insured</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-[#00F0FF]" />
              <span className="text-sm">Free Estimates</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-[#00F0FF]" />
              <span className="text-sm">Satisfaction Guaranteed</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
